import { useMutation } from '@tanstack/react-query';
import { useShallow } from 'zustand/shallow';
import { useGlobalStore } from '../stores/globalStore';
import { bffLoginInitiateOtp } from '../api/client';
import { encrypt } from '../utils/encrypt';

export const useSendOTP = () => {
    const { lang } = useGlobalStore(useShallow((state) => ({
        lang: state.lang,
    })));

    const { mutateAsync: sendOTP } = useMutation({
        mutationFn: ({ number, customerName }: { number: string; customerName: string }) => {
            const encNumber = number ? encrypt(number) : '';
            const encCustomerName = customerName ? encrypt(customerName) : '';

            return bffLoginInitiateOtp({
                number: encNumber,
                customerName: encCustomerName,
                lang: lang,
            })
        },
    });

    return sendOTP;
}